/* Semedi cart drawer.
 * - Intercepts add-to-cart forms (form[action*="/cart/add"]) and adds via /cart/add.js, then re-renders
 *   the drawer section (Section Rendering API) and opens it.
 * - Quantity buttons ([data-pn-line]) use /cart/change.js; swap cards ([data-pn-swap]) remove one line unit
 *   with /cart/change.js and add the new variant with /cart/add.js.
 * - Keeps cart counters ([data-pn-cart-count]) and free-shipping lines ([data-pn-ship]) in sync.
 * Quick-add buttons with class pn4-add get aria-busy while adding and is-added for a moment afterwards.
 * Forms with return_to=/checkout or data-pn-no-drawer keep their native behaviour. Any failure falls back
 * to the native form submit, so buying never depends on this script.
 */
(function () {
  'use strict';
  if (window.__pnCart) return;
  window.__pnCart = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lastFocus = null;
  var busy = false;

  function drawer() { return document.querySelector('[data-pn-drawer]'); }
  function sectionId() { var d = drawer(); return d ? d.getAttribute('data-section') : null; }

  function fmt(cents) {
    try { return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' zł'; }
  }

  function open() {
    var d = drawer();
    if (!d) return false;
    lastFocus = document.activeElement;
    d.hidden = false;
    document.documentElement.classList.add('pn-dr-lock');
    requestAnimationFrame(function () {
      d.classList.add('is-open');
      var p = d.querySelector('.pn-dr-panel');
      if (p) p.focus({ preventScroll: true });
    });
    return true;
  }

  function close() {
    var d = drawer();
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('pn-dr-lock');
    setTimeout(function () { d.hidden = true; }, 220);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function syncFromDrawer() {
    var d = drawer();
    if (!d) return;
    var count = parseInt(d.getAttribute('data-count') || '0', 10);
    var total = parseInt(d.getAttribute('data-total') || '0', 10);
    document.querySelectorAll('[data-pn-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
    document.querySelectorAll('[data-pn-ship]').forEach(function (el) {
      if (el.closest('[data-pn-drawer]')) return;
      var thr = parseInt(el.getAttribute('data-threshold') || '14900', 10);
      var left = thr - total;
      var t = el.querySelector('[data-pn-ship-text]');
      el.classList.toggle('is-free', left <= 0);
      if (t) {
        if (left <= 0) t.innerHTML = '<strong>Masz darmową dostawę.</strong>';
        else if (total === 0) t.textContent = 'Darmowa dostawa od ' + fmt(thr).replace(/,00(?=\s)/, '') + '.';
        else t.innerHTML = 'Do darmowej dostawy brakuje <strong>' + fmt(left) + '</strong>.';
      }
      var fill = el.querySelector('[data-pn-ship-fill]');
      if (fill) fill.style.width = Math.min(100, Math.round(total * 100 / thr)) + '%';
    });
    document.dispatchEvent(new CustomEvent('pn:cart', { detail: { count: count, total: total } }));
  }

  function render(html) {
    var d = drawer();
    if (!d || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-pn-drawer]');
    if (!fresh) return;
    var wasOpen = !d.hidden;
    d.innerHTML = fresh.innerHTML;
    d.setAttribute('data-count', fresh.getAttribute('data-count'));
    d.setAttribute('data-total', fresh.getAttribute('data-total'));
    if (wasOpen) d.hidden = false;
    syncFromDrawer();
  }

  function post(url, body, isForm) {
    var sid = sectionId();
    var opts = { method: 'POST', headers: { Accept: 'application/json' }, credentials: 'same-origin' };
    if (isForm) {
      if (sid) { body.append('sections', sid); body.append('sections_url', window.location.pathname); }
      opts.body = body;
    } else {
      if (sid) { body.sections = sid; body.sections_url = window.location.pathname; }
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(root + url, opts).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || 'cart error');
        return j;
      });
    });
  }

  function refresh() {
    var sid = sectionId();
    if (!sid) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sid), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { render(j[sid]); });
  }

  function setBusy(on) {
    busy = on;
    var d = drawer();
    if (d) d.classList.toggle('is-busy', on);
  }

  // Add to cart
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || e.defaultPrevented) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (!drawer() || form.hasAttribute('data-pn-no-drawer')) return;
    var rt = form.querySelector('input[name="return_to"]');
    if (rt && rt.value.indexOf('/checkout') === 0) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var fd = new FormData(form);
    fd.delete('return_to');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    setBusy(true);
    var added = false;
    post('cart/add.js', fd, true)
      .then(function (j) {
        added = true;
        if (j.sections) render(j.sections[sectionId()]); else return refresh();
      })
      .then(function () {
        open();
        if (btn && btn.classList.contains('pn4-add')) {
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 2400);
        }
      })
      .catch(function () {
        // Fall back to a normal form post only when the item was not added; otherwise just show the cart.
        if (added) { window.location.href = root + 'cart'; } else { HTMLFormElement.prototype.submit.call(form); }
      })
      .finally(function () {
        setBusy(false);
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      });
  });

  // Drawer clicks
  document.addEventListener('click', function (e) {
    var t = e.target instanceof Element ? e.target : null;
    if (!t) return;

    var opener = t.closest('a[href$="/cart"].pn-cartbtn, [data-pn-open-cart]');
    if (opener && drawer()) {
      e.preventDefault();
      open();
      return;
    }

    if (t.closest('[data-pn-drawer-close]')) { e.preventDefault(); close(); return; }

    var line = t.closest('[data-pn-line]');
    if (line && !busy) {
      e.preventDefault();
      setBusy(true);
      post('cart/change.js', { id: line.getAttribute('data-pn-line'), quantity: parseInt(line.getAttribute('data-qty'), 10) || 0 })
        .then(function (j) { if (j.sections) render(j.sections[sectionId()]); })
        .catch(function () { window.location.href = root + 'cart'; })
        .finally(function () { setBusy(false); });
      return;
    }

    var swap = t.closest('[data-pn-swap]');
    if (swap && !busy) {
      e.preventDefault();
      setBusy(true);
      var removeQty = parseInt(swap.getAttribute('data-remove-qty'), 10) || 0;
      // Add the new item first, so a failed add never leaves the customer without the original product.
      fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(swap.getAttribute('data-add'), 10), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); })
        .then(function () { return post('cart/change.js', { id: swap.getAttribute('data-remove'), quantity: removeQty }); })
        .then(function (j) {
          if (!drawer()) { window.location.reload(); return; }
          if (j.sections) render(j.sections[sectionId()]); else return refresh();
        })
        .catch(function () { if (!drawer()) { window.location.reload(); return; } return refresh(); })
        .finally(function () { setBusy(false); });
    }
  });

  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (!d || d.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = d.querySelectorAll('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  window.SemediCart = { open: open, close: close, refresh: refresh };
})();
